import { Command } from './Command';
import { ChartEngine, GraphElement } from '../core/ChartEngine';

export class AddGraphCommand implements Command {
  constructor(
    private regionId: string,
    private layerId: string,
    private graphData: GraphElement
  ) {}

  execute(engine: ChartEngine): void {
    engine.addElementToLayer(this.regionId, this.layerId, this.graphData);
  }

  undo(engine: ChartEngine): void {
    engine.removeElementFromLayer(this.regionId, this.layerId, this.graphData.id);
  }
}